import axios from 'axios'
import Modal from 'bootstrap/js/src/modal'
import Dropdown from 'bootstrap/js/src/dropdown'

export default class DocumentSign {
    constructor() {
        // checkboxy
        this.elementFormDocumentTerms = document.getElementById('form-document-terms')

        //podpisywanie dokumentu
        this.elementDocumentConsentModal = document.getElementById('document-consent-modal')
        this.elementSectionConsents = document.getElementById('section-consents')
        this.consentModal = new Modal(this.elementDocumentConsentModal)

        //odmowa podpisania dokumentu
        this.elementBtnDocumentDecline = document.getElementById('btn-document-decline')
        this.elementDocumentDeclineModal = document.getElementById('document-decline-modal')
        this.elementFormDocumentDecline = document.getElementById('form-document-decline')
        this.elementInputDeclineMessage = document.getElementById('input-decline-message')
        this.declineModal = new Modal(this.elementDocumentDeclineModal)

        // zadanie podpisu w toku - blokuje ponowne wyslanie formularza
        this.signing = false

    }
    sign() {
        //zgody -> podpis (kod SMS zostal potwierdzony w bramce przed dokumentem)
        this.elementFormDocumentTerms.addEventListener('submit',(e) => {
            e.preventDefault()
            if(this.signing) {
                return
            }
            if(this.isValidForm(this.elementFormDocumentTerms)) {
                const button = document.getElementById('form-document-consent-modal-submit-terms-button')
                this.signing = true
                this.setBtnLoadingState(button, true)
                this.signRequest()
                    .then(() => {
                        this.consentModal.hide()
                        window.location.href = `/documents/signed/${DOCUMENT_ID}/${SIGNER_HASH}/${SIGNER}`
                    })
                    .catch((error) => {
                       if(error.response && error.response.status === 403) {
                           window.location.reload()
                           return
                       }
                       this.signing = false
                       this.setBtnLoadingState(button, false)
                       if(error.response.data.hasOwnProperty('error')) {
                           document.getElementById('document-consent-modal-section-errors').innerHTML = '<div class="alert alert-warning my-3 w-100">' + error.response.data.error + '</div>';
                       }
                    })
                    .finally(()=>{
                        document.getElementById('document-consent-modal-section-spinner').classList.add('d-none')
                    })

            }else {
                this.showTermsSection()
            }
        })

       // okno podpisywania
        this.elementDocumentConsentModal.addEventListener('show.bs.modal',  (event) => {
            // resetowanie akceptacji regulaminu
            document.getElementById('consent-1').checked = false
            document.getElementById('form-document-terms').classList.remove('was-validated')
            this.showTermsSection()
            document.getElementById('document-consent-modal-footer').classList.remove('d-none')

        })

    }

    decline() {
        [].slice.call(document.querySelectorAll('.btn-decline')).map((el)=>{
            el.addEventListener('click',(e)=>{
                this.openDeclineModal()
            })
        })
    }

    openDeclineModal(){
        this.declineModal.show()
        this.elementDocumentDeclineModal.addEventListener('hidden.bs.modal', (event) => {
            this.elementFormDocumentDecline.reset()
            this.elementFormDocumentDecline.classList.remove('was-validated')
        })

        this.elementFormDocumentDecline.addEventListener('submit',  (event) => {
            event.preventDefault()
            if(this.isValidForm(this.elementFormDocumentDecline)) {
                this.declineRequest().then(()=> {
                    window.location.reload(true);
                }).catch((e) => {
                    if(e.response && e.response.status === 403) {
                        window.location.reload()
                        return
                    }
                    if(e.response.data.hasOwnProperty('error')) {
                        document.getElementById('document-decline-modal-alert').innerHTML = '<div class="alert alert-danger my-3">'+ e.response.data.error +'</div>'
                        setTimeout(()=> {
                            document.getElementById('document-decline-modal-alert').innerHTML = ''
                        },5000)
                    }
                })
            }
            this.elementFormDocumentDecline.classList.add('was-validated')


        }, false)
    }
    signRequest() {
        return axios.post('/documents/sign',{
            documentId: DOCUMENT_ID,
            signer: SIGNER
        })
    }
    declineRequest() {
        return axios.post('/documents/cancel',{
            documentId: DOCUMENT_ID,
            message: this.elementInputDeclineMessage.value,
            signer: SIGNER
        })
    }
    setBtnLoadingState(element, state) {
        let spinner = element.querySelector('.spinner-border')
        element.disabled = state
        state ? spinner.classList.remove('invisible') : spinner.classList.add('invisible')
    }
    isValidForm(form) {
        form.classList.add('was-validated')
        return form.checkValidity()
    }
    showTermsSection() {
        document.getElementById('document-consent-modal-section-terms').classList.remove('d-none')
        document.getElementById('form-document-consent-modal-submit-terms-button').classList.remove('d-none')
    }
}
